/*
 * 跨页补发 GA4 事件（全站，由 layout/theme.liquid 加载）。
 * assets/lp-analytics.js 遇到「点击后当前页立即跳走」的事件（目前只有推荐卡普通左键的 *_recommendation_interaction / card_click）
 * 时不在原页发，而是写进 sessionStorage 'nx_pending_ga_events'：[{ id, ts, name, params }]，params 已含 send_to / debug_mode。
 * 本脚本在每页加载后：等 Shopify Customer Privacy 分析类同意 + 渠道 gtag 把 G-3YWS0LBN5K 的 config 放进 dataLayer，
 * 再逐条 gtag('event', name, params) 发出。官方 API 之外不做任何上报。
 *   - 发之前先从 sessionStorage 取走（读改写同步完成，同一标签页内不会被重复取），按 id 去重，只发一次；
 *   - 超过 30 分钟的丢弃；
 *   - 同意 API 已加载但不放行 → 整批丢弃；20s 内 gtag 一直没就绪 → 留着等下一页（30 分钟后过期）。
 * 只有本脚本负责补发，lp-analytics.js 只写不发，所以不会双发。
 */
(() => {
  const KEY = 'nx_pending_ga_events';
  const MEASUREMENT_ID = 'G-3YWS0LBN5K';
  const MAX_AGE_MS = 30 * 60 * 1000;
  const POLL_MS = 500;
  const WAIT_MS = 20000;
  const SETTLE_MS = 1000;

  const read = () => {
    try {
      const list = JSON.parse(window.sessionStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch {
      return [];
    }
  };
  if (!read().length) return;

  const take = () => {
    const list = read();
    try {
      window.sessionStorage.removeItem(KEY);
    } catch {}
    const seen = new Set();
    return list.filter((item) => item && item.id && item.name && Date.now() - item.ts < MAX_AGE_MS
      && !seen.has(item.id) && seen.add(item.id));
  };

  const privacy = () => window.Shopify?.customerPrivacy;
  const consentOk = () => {
    try {
      return !!privacy()?.analyticsProcessingAllowed?.();
    } catch {
      return false;
    }
  };
  const tagReady = () => Array.isArray(window.dataLayer)
    && window.dataLayer.some((command) => command?.[0] === 'config' && command?.[1] === MEASUREMENT_ID);

  const started = Date.now();
  const poll = () => {
    if (consentOk() && tagReady() && typeof window.gtag === 'function') {
      window.setTimeout(() => take().forEach(({ name, params }) => window.gtag('event', name, params)), SETTLE_MS);
      return;
    }
    if (Date.now() - started < WAIT_MS) {
      window.setTimeout(poll, POLL_MS);
      return;
    }
    // 同意 API 在、但访客没同意：丢弃；API 没加载 / gtag 没就绪：留给下一页
    if (privacy()?.analyticsProcessingAllowed && !consentOk()) take();
  };
  poll();
})();
